import React from 'react';
import UnknownMonoHtmlView from './UnknownHtml';
import UnknownMonoReactView from './Unknown';
const UnknownMonoView = (props)=>{
    if (props.isHtml) {
        return /*#__PURE__*/ React.createElement(UnknownMonoHtmlView, props);
    }
    return /*#__PURE__*/ React.createElement(UnknownMonoReactView, props);
};
UnknownMonoView.displayName = 'UnknownMonoView';
export default UnknownMonoView;

//# sourceMappingURL=index.js.map